module.exports = __webpack_public_path__ + "img/linkedin.ed41c3e7.png";